import UserTaxiOfficerListResponse, {
  UserTaxiOfficerListResponseItem,
} from "../../../../api/raily/user/taxi-officer/list/user-taxi-officer-list.response";
import { UserTaxiOfficerListItem } from "./user-taxi-officer-list";
import UserTaxiOfficerList from "./user-taxi-officer-list";

const createAlternativePhoneNumber = (
  responseDataItem: UserTaxiOfficerListResponseItem,
): UserTaxiOfficerListItem["alternativePhoneNumber"] => {
  if (
    !responseDataItem.mobileSecondary ||
    !responseDataItem.mobileSecondaryPrefix
  ) {
    return null;
  }

  return {
    dialingCode: responseDataItem.mobileSecondaryPrefix,
    number: responseDataItem.mobileSecondary,
  };
};

const createPhoneNumber = (
  responseDataItem: UserTaxiOfficerListResponseItem,
): UserTaxiOfficerListItem["phoneNumber"] => {
  return {
    dialingCode: responseDataItem.mobilePrimaryPrefix,
    number: responseDataItem.mobilePrimary,
  };
};

const createDataItem = (
  responseDataItem: UserTaxiOfficerListResponseItem,
): UserTaxiOfficerListItem => {
  return {
    uuid: responseDataItem.id,
    removalDate: responseDataItem.removedAt,
    alternativePhoneNumber: createAlternativePhoneNumber(responseDataItem),
    email: responseDataItem.email,
    firstName: responseDataItem.firstName,
    lastName: responseDataItem.lastName,
    username: responseDataItem.username,
    phoneNumber: createPhoneNumber(responseDataItem),
  };
};

const createData = (
  responseData: UserTaxiOfficerListResponseItem[],
): UserTaxiOfficerListItem[] => {
  return responseData.map(createDataItem);
};

const create = (response: UserTaxiOfficerListResponse): UserTaxiOfficerList => {
  return {
    data: createData(response.data.data),
    totalCount: response.data.totalCount,
  };
};

const userTaxiOfficerListFactory = {
  create,
};

export default userTaxiOfficerListFactory;
